module.exports = __webpack_public_path__ + "img/avatar.d5c7beac.jpg";